import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postSendToken = (email, companyName) => {
    return fetch(`${getApiUrl()}send_token/${email}/${companyName}`, {
        method: "POST"
    })
}

export default postSendToken